import React from 'react'
import styled from 'styled-components'
import GoogleMapReact from 'google-map-react'
import { IoMdPin } from 'react-icons/io'
import { device } from './Breakpoints'
import { colors } from './Colors'
import imgcentralate from '../icons/centralate.svg'

class CentralAtendimento extends React.Component {
  constructor(props) {
    super()
    this.state = {
      ...props,
    }
  }

  render() {
    const { title, central } = this.state

    const GroupContent = styled.section`
      padding: 2em 0;
      background: ${colors.laranjaGradienteReverso};
      color: #ffffff;
      h2 {
        color: #ffffff;
      }
      @media ${device.mobileL} {
        padding: 2em;
        p,
        h2 {
          text-align: left;
        }
      }

      .inner {
        justify-content: space-between;
        p {
          font-size: 0.8em;
        }
        @media ${device.mobileL} {
          flex-wrap: wrap;
        }
        h2 {
          color: #8e8fc7;
          margin-top: 0;
        }
        .probtrat {
          p {
            padding-bottom: 10px;
            :nth-child(1) {
              color: #ffff00;
              padding-bottom: 15px;
            }
          }
          margin-bottom: 20px;
          padding: 20px;
          color: #ffffff;
          background-color: #148581;
        }
        li {
          font-size: 0.8em;
          text-align: left;
        }
        .estrutura {
          display: flex;
          align-items: center;
          padding-top: 0;
          div {
            width: 50%;
            :nth-child(1) {
              padding-right: 20px;
            }
            @media ${device.mobileL} {
              width: 100%;
            }
          }
          img {
            width: 100%;
            margin: 0;
          }
          @media ${device.mobileL} {
            display: inline;
            justify-content: center;
          }
        }
        .maternidade {
          width: 100%;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          margin: 40px 0;
          padding: 0;
          .prolapso {
            width: 18%;
            @media ${device.mobileL} {
              width: 100%;
              margin: 0 0 10px 0;
            }
          }
          div {
            padding: 30px 15px;
            margin: 0 30px 30px 0;
            background-color: white;
            box-shadow: 0px 0px 11px 0px rgba(0, 0, 0, 0.5);
            width: 27%;
            @media ${device.mobileL} {
              width: 100%;
              margin: 0 0 10px 0;
            }
          }
          p {
            width: 100%;
            color: black;
            text-align: left;
            position: relative;
            top: 0em;
          }

          h4 {
            font-size: 0.8em;
            color: #8e8fc7;
          }
        }
        .atendimento {
          p {
            display: inline;
            color: #ffffff;
            font-size: 0.8em;
          }
          .tel {
            display: flex;
            text-justify: top;
            p {
              margin: 0 0 0 20px;
              position: relative;
              @media ${device.mobileL} {
                display: block;
              }
              :after {
                content: '';
                border-bottom: 1px solid #f4edc6;
                width: 35px;
                position: absolute;
                bottom: 0px;
                left: 0;
              }
            }
          }
          .central {
            display: flex;
            align-items: center;
            h3 {
              color: #f4edc6;
              font-size: 1.5em;
              @media ${device.mobileL} {
                font-size: 1.3em;
              }
            }
            p {
              display: block;
              margin: 2px;
            }
            div {
              width: 100%;
              @media ${device.mobileL} {
                display: block;
              }
            }
            .info {
              padding-left: 3em;
              @media ${device.mobileL} {
                padding: 0;
              }
              div {
                padding: 20px 0;
                position: relative;
                :last-child {
                  :after {
                    border: none;
                  }
                }
                :after {
                  content: '';
                  border-bottom: 1px solid #f4edc6;
                  width: 35px;
                  position: absolute;
                  bottom: 0px;
                  left: 0;
                }
                h3 {
                  margin: 5px 0;
                }
                a {
                  color: #ffffff;
                }
              }
            }

            .map {
              width: 100%;
              height: 300px;
              border: 1px solid #148581;
              @media ${device.mobileL} {
                position: static;
                width: 100%;
                height: 200px;
              }
            }
            @media ${device.mobileL} {
              display: block;
            }
          }
        }
      }
    `

    const Map = () => (
      <div>
        <IoMdPin size="2em" color="red" />
      </div>
    )

    return (
      <GroupContent>
        <div className="inner center">
          <div className="atendimento">
            <div className="tel">
              <img src={imgcentralate} alt="Telefone" />
              <p>{title}</p>
            </div>
            <div className="central">
              <div className="info">
                <div>
                  <h3>{central}</h3>
                  <a href="tel:(11)5080-6000"> (11) 5080-6000</a>
                </div>
                <div>
                  <p>Horário de agendamento</p>
                  <p>De 2ª a 6ª feira, das 07h às 20h, exceto feriados</p>
                  <p>Sábados, das 07h às 13h</p>
                </div>
                <div>
                  <p>Endereço</p>
                  <p>Rua do Paraíso, 432 - Paraíso</p>
                  <p>São Paulo</p>
                </div>
              </div>
              <div>
                <div className="map">
                  <GoogleMapReact
                    bootstrapURLKeys={{
                      key: 'AIzaSyCLOHkYMoPTOSfoQxhwpV4wXbo1EkYJvqI',
                    }}
                    yesIWantToUseGoogleMapApiInternals
                    defaultCenter={{ lat: -23.5740475, lng: -46.6392942 }}
                    defaultZoom={16}
                  >
                    <Map lat={-23.5740475} lng={-46.6392942} />
                  </GoogleMapReact>
                </div>
              </div>
            </div>
          </div>
        </div>
      </GroupContent>
    )
  }
}

export default CentralAtendimento
